define('controller/step/datetime/BaseDateTimeStep',['require','lib/controller/booking/BaseStep','view/controller/booking/datetime/DateTimeStepDefaultLayout','view/controller/booking/datetime/DateTimeStepInlineLayout','view/controller/booking/datetime/SidebarView','view/controller/booking/datetime/DateDefaultView','view/controller/booking/datetime/DateInlinePickerView','collection/WorkingDayCollection','model/DayModel','Config','lib/view/BookingUrlBuilder'],function (require) {

    var BaseStep = require('lib/controller/booking/BaseStep');
    var DateTimeStepDefaultLayout = require('view/controller/booking/datetime/DateTimeStepDefaultLayout');
    var DateTimeStepInlineLayout = require('view/controller/booking/datetime/DateTimeStepInlineLayout');
    var SidebarView = require('view/controller/booking/datetime/SidebarView');
    var DateDefaultView = require('view/controller/booking/datetime/DateDefaultView');
    var DateInlinePickerView = require('view/controller/booking/datetime/DateInlinePickerView');
    var WorkingDayCollection = require('collection/WorkingDayCollection');
    var DayModel = require('model/DayModel');
    var COnfig = require('Config');
    var BookingUrlBuilder = require('lib/view/BookingUrlBuilder');

    /**
     * Base datetime step. With select single date
     * 
     * @class BaseDateTimeStep
     */
    return BaseStep.extend({
        
    	_step: 'datetime',
    	_calendarCollection: null,
        _timeCollection: null,
        _currentYear: null,
        _currentMonth: null,
        _dateView: null,
        _currentDate: null,
        _timeValidateModel: null,
        _timeValidated: false,
        _prevValidatedData: {},
        _supportsTimelineNavigation: false,
        _prevRequest: null,

        /**
         * Inits instance
         */
        initialize: function() {
            BaseStep.prototype.initialize.call(this);

            this._initTimeValidateModel();
            this._initCalendarCollection();
            this._initTimeCollection();

            this.listenTo(this._bookingModel, 'change:start_date', this._updateTimeCollection);
            this.listenTo(this._bookingModel, 'change', this._resetCurrentPeriod);
            this.listenTo(this._timeCollection, 'sync error', this._updateSelectedDates);
            this.listenTo(this.getOption('clientTimeZone'), 'sync', this._fetchTimeCollection);
        },

        start: function () {
            this._updateCalendarCollection(this._bookingModel.get('start_date'));
            this._updateTimeCollection();
        },

        /**
         * Returns datetime step layout
         * 
         * @return DateTimeStepDefaultLayout
         */
        getView: function () {
            this._updateTimeCollection();

            var dateTimeLayout = this._getLayoutInstance({
                model: this.getOption('bookingModel'),
                clientTimeZone: this.getOption('clientTimeZone')
            });

            this.listenTo(dateTimeLayout, 'show', this.showRegions);

            this._supportsTimelineNavigation = dateTimeLayout.supportsTimelineNavigation();

            return dateTimeLayout;
        },

        /**
         * Updates exists view
         */
        refreshView: function () {
            this._updateFirstDay();
        },

        /**
         * Returns datetime layout instance
         *
         * @protected
         * @return DateTimeStepDefaultLayout
         */
        _getLayoutInstance: function (options) {
            switch (Config.getInstance().getOption('datepicker_type')) {
                case 'inline_datepicker':
                    return new DateTimeStepInlineLayout(options);
                default:
                    return new DateTimeStepDefaultLayout(options);
            }
        },

        /**
         * When layout appears add date and time view to layout regions
         * 
         * @param DateTimeStepDefaultLayout layout
         */
        showRegions: function (layout) {
            layout.getDateRegion().show(this._getDateView());
            if (layout.supportsSidebar()) {
                layout.getSideBarRegion().show(this._getSideBarView());
            }

            var timeView = this._getTimeView();
            if (timeView) {
                layout.getTimeRegion().show(timeView);

                this.listenTo(timeView, 'nextAvailableDate', this._nextAvailableDate);
            }

            this._resetCurrentDate();
            this._updateFirstDay();

            Backbone.Wreqr.radio.vent.trigger('timeline', 'shown', layout);
        },

        /**
         * Reset current selected date to allow time collection fetch new data
         *
         * @protected
         */
        _resetCurrentDate: function () {
            this._currentDate = null;
        },

        /**
         * Rset current period to allow date collection fetch new data
         *
         * @protected
         */
        _resetCurrentPeriod: function (model) {
            var changed = Object.keys(model.changed);
            var affects = ['service_id', 'provider_id', 'location_id', 'category_id'];
            var changedAttrs = changed.filter(function(n) {
                return affects.indexOf(n) !== -1;
            });

            if (changedAttrs.length) {
                this._currentMonth = null;
                this._currentYear = null;
            }
        },

        /**
         * Returns true if date and time is set, else returns false
         * 
         * @return Boolean
         */
        isValid: function () {
            if (this._bookingModel.get('start_date') && this._bookingModel.get('start_time')) {
                if (!this._timeValidated) {
                    this._validateBookingTime();

                    return false;
                }

                return true;
            }
            return false;
        },

        /**
         * Initializes validate booking time model info
         *
         * @protected
         */
        _initTimeValidateModel: function () {
            this._timeValidateModel = this.getOption('timeValidateModel');

            this.listenTo(this._timeValidateModel, 'sync', this._updateValidatedData);
            this.listenTo(this._bookingModel, 'change', this._updateTimeValidateFlag);
        },

        /**
         * Callback when time validating data is loaded
         *
         * @protected
         */
        _updateValidatedData: function () {
            if (!this._timeValidateModel.get('error')) {
                this._timeValidated = true;

                this.done();
            }
        },

        /**
         * Check if service, provider, date or time has been changed, then reset time validate data flag
         *
         * @private
         */
        _updateTimeValidateFlag: function () {
            var data = this._getDataForTimeValidateInfo(true);

            for (var key in data) {
                if (data.hasOwnProperty(key) && !data[key]) {
                    this._timeValidateModel.set('error', null);

                    return;
                }
            }

            data = this._getDataForTimeValidateInfo(false);
            for (key in data) {
                if (!data.hasOwnProperty(key)) {
                    continue;
                }
                if (this._bookingModel.changed[key]) {
                    this._timeValidated = false;
                    this._prevValidatedData = {};

                    this._timeValidateModel.set('error', null);
                }
            }
        },

        /**
         * Load validating time data and check if it is valid
         *
         * @protected
         */
        _validateBookingTime: function () {
            if (!this._timeValidated) {
                var data = this._getDataForTimeValidateInfo(false);
                if (_.isEqual(data, this._prevValidatedData)) {
                    return;
                }

                this._prevValidatedData = data;

                this._timeValidateModel.fetch({
                    reset:true,
                    data: jQuery.param(data)
                });
            }
        },

        /**
         * Returns data for validating time
         *
         * @protected
         */
        _getDataForTimeValidateInfo: function (requiredOnly) {
            var result = {
                provider_id: this._bookingModel.get('provider_id'),
                service_id: this._bookingModel.get('service_id'),
                start_date: this._bookingModel.get('start_date'),
                start_time: this._bookingModel.get('start_time'),
                count: this._bookingModel.get('count')
            };

            if (!requiredOnly) {
                result.products = this._bookingModel.getAddons();
            }

            return result;
        },

        /**
         * Inits calendar collection, fetch data from server
         *
         * @protected
         */
        _initCalendarCollection: function () {
        	this._calendarCollection = new WorkingDayCollection();
            var waitingListHelperModel = this.getOption('waitingListHelperModel');
            if(waitingListHelperModel){
                waitingListHelperModel.setCalendarCollection(this._calendarCollection)
            }
        },

        /**
         * Fetch working days information from server for calendar collection
         * 
         * @param Date date
         * @private
         */
        _updateCalendarCollection: function (date) {
	    	if (!date) {
	    	    return;
	    		//date = new Date();
	    	} else if (!_.isDate(date)) {
	    		date = Date.parseMysqlDate(date);
	    	}

	    	if (this._currentYear === date.getFullYear() && this._currentMonth === date.getMonth()) {
	    		return;
	    	}

            this._currentYear = date.getFullYear();
            this._currentMonth = date.getMonth();

            if (this._dateView) {
                this._dateView.setCurrentYearMonth(this._currentYear, this._currentMonth);
            }

            var dates = this._getStartEndDate(date);
	    	this._calendarCollection.fetch({
	    		data: {
	    			'from': dates.from.getMysqlDate(),
	    			'to': dates.to.getMysqlDate(),
	    			'provider': this._bookingModel.get('provider_id'),
                    'service': this._bookingModel.get('service_id'),
                    'products': this._bookingModel.getAddons(),
                    'location': this._bookingModel.get('location_id'),
                    'category': this._bookingModel.get('category_id'),
                    'booking_id': this._bookingModel.id
	    		}
	    	});
	    },

        /**
         * Returns start and end dates to load working calendar
         *
         * @param Date date
         * @protected
         */
        _getStartEndDate: function (date) {
            var from = new Date(date);
            from.setDate(1);

            var diff = from.getDay();
            if (Config.getInstance().isMondayFirstDay()) {
                diff--;
                // fix monday the 1st getting out of range
                if (diff == -1) diff = 6;
            }
            from.setDate(from.getDate() - diff);

            var to = new Date(from);

            to.setDate(to.getDate() + 41);

            return {
                'from': from,
                'to': to
            };
        },

	    /**
	     * Updates first working day
         *
         * @protected
	     */
        _updateFirstDay: function () {
            var instance = this;
            
            if (!this._bookingModel.get('start_date')) {
                if (!this._firstDayModel) {
                    this._firstDayModel = new DayModel({
                        url: '/booking/first-working-day'
                    });
                    this._firstDayModelParams = {};
                }
                
                var newParams = {
                    'location': this._bookingModel.get('location_id'),
                    'provider': this._bookingModel.get('provider_id'),
                    'service': this._bookingModel.get('service_id'),
                    'products': this._bookingModel.getAddons(),
                    'timeline': Config.getInstance().getOption('timeline_type')
                };
                
                if (!_.isEqual(this._firstDayModelParams, newParams)) {
                    this._firstDayModelParams = newParams;
                    this._firstDayModel.fetch({
                        data: this._firstDayModelParams,
                        success: function (model) {
                            var date = Date.parseMysqlDate(model.get('date'));
                            
                            instance._bookingModel.set('start_date', date.getMysqlDate());
                            instance._updateCalendarCollection(date.getMysqlDate());
                        }
                    });
                } else {
                    if (this._firstDayModel.get('date')) {
                        var date = Date.parseMysqlDate(this._firstDayModel.get('date'));
                        
                        instance._bookingModel.set('start_date', date.getMysqlDate());
                        instance._updateCalendarCollection(date.getMysqlDate());
                    } // else skip - date is not loaded yet
                }                
            }
        },

        _nextAvailableDate: function () {
            var currentDate = this._bookingModel.get('start_date');
            var _this = this;

            var nextDayModel = new DayModel({
                url: '/booking/next-working-day',
            });

            nextDayModel.fetch({
                data: {
                    'date': currentDate,
                    'location': this._bookingModel.get('location_id'),
                    'provider': this._bookingModel.get('provider_id'),
                    'service': this._bookingModel.get('service_id'),
                    'products': this._bookingModel.getAddons(),
                    'timeline': Config.getInstance().getOption('timeline_type')
                },
                success: function (model) {
                    var date = Date.parseMysqlDate(model.get('date'));

                    _this._bookingModel.set('start_date', date.getMysqlDate());
                    _this._updateCalendarCollection(date.getMysqlDate());

                    var url = BookingUrlBuilder.getInstance().buildUrl('booking_step', {
                        'date': model.get('date')
                    });
        
                    if (!model.skipNavigationOnCalendar) {
                        Backbone.history.navigate(url);
                    }
                }
            });
        },

        /**
         * Updates time on user select time
         *
         * @param String time
         * @param String date
         * @protected
         */
        _updateSelectedTime: function (time, date, isWaitingList) {
            var urlBuilder = this.getOption('stepManager').getUrlBuilder();
            Backbone.history.navigate(urlBuilder.buildUrl(this.getOption('stepManager').getRouteName(), {
                time: time,
                date: date,
                wl: isWaitingList
            }), {'trigger': true});
        },

        /**
         * Returns date view
         * 
         * @return DateDefaultView
         * @protected
         */
        _getDateView: function () {
            this._dateView = this._getDateViewInstance({
                model: this._bookingModel,
                collection: this._calendarCollection,
                clientTimeZone: this.getOption('clientTimeZone')
            });

            this._dateView.setCurrentYearMonth(this._currentYear, this._currentMonth);

	    	this.listenTo(this._dateView, 'prevMonth', this._prevMonth);
            this.listenTo(this._dateView, 'nextMonth', this._nextMonth);
            this.listenTo(this._dateView, 'changeMonth', this._setMonth);

            this._updateSelectedDates();

	    	return this._dateView;
        },

        /**
         * Returns sidebar booking info view
         *
         * @protected
         * @return SidebarView
         */
        _getSideBarView: function () {
            return new SidebarView({
                model: this.getOption('bookingModel')
            });
        },

        /**
         * Returns date view class instance
         *
         * @protected
         * @return BaseDateView
         */
        _getDateViewInstance: function (options) {
            switch (Config.getInstance().getOption('datepicker_type')) {
                case 'inline_datepicker':
                    return new DateInlinePickerView(options);
                default:
                    return new DateDefaultView(options);
            }
        },

        /**
         * Move to prev month
         *
         * @protected
         */
        _prevMonth: function () {
            var date = new Date();
            date.setDate(1);
            date.setFullYear(this._currentYear, this._currentMonth - 1);

            this._updateCalendarCollection(date);
        },

        /**
         * Move to next month
         *
         * @protected
         */
        _nextMonth: function () {
            var date = new Date();
            date.setDate(1);
            date.setFullYear(this._currentYear, this._currentMonth + 1);

            this._updateCalendarCollection(date);
        },

        /**
         * Set current month
         *
         * @protected
         */
        _setMonth: function (year, month) {
            var date = new Date();
            date.setDate(1);
            date.setFullYear(year, month);

            this._updateCalendarCollection(date);
        },

        /**
         * Here you should init time collection
         *
         * @protected
         */
	    _initTimeCollection: function () {
	    },

        /**
         * Perform load time collection from server if needed
         *
         * @protected
         */
        _updateTimeCollection: function () {
            if (!this._requiresFetchingTimeCollection()) {
                return;
            }
            
            this._rememberTimeCollectionParams();

            this._fetchTimeCollection();
        },
        
        _requiresFetchingTimeCollection: function () {
            return this._currentDate !== this._bookingModel.get('start_date');
        },
        
        _rememberTimeCollectionParams: function () {
            this._currentDate = this._bookingModel.get('start_date');
        },

        /**
         * Updates selected dates in date view
         *
         * @protected
         */
        _updateSelectedDates: function () {
            if (this._dateView) {
                this._dateView.setSelectedDates(this._getSelectedDates());
            }
        },

        /**
         * Returns current selected dates
         *
         * @protected
         * @return array
         */
        _getSelectedDates: function () {
            var result = [];
            if (this._bookingModel.get('start_date')) {
                result.push(this._bookingModel.get('start_date'));
            }

            return result;
        },

        /**
         * Fetches time collection from server
         */
        _fetchTimeCollection: function () {
            if (!this._bookingModel.get('start_date')) {
                this._timeCollection.reset();
                return;
            }
            
            var date = Date.parseMysqlDate(this._bookingModel.get('start_date'));

            var prev = this._prevRequest;
            
            this._timeCollection.unsetSynchronizedFlag();
            this._timeCollection.trigger('refetch');
            this._prevRequest = this._timeCollection.fetch({
                data: {
                    'from': date.getMysqlDate(),
                    'to': date.getMysqlDate(),
                    'location': this._bookingModel.get('location_id'),
                    'category': this._bookingModel.get('category_id'),
                    'provider': this._bookingModel.get('provider_id'),
                    'service': this._bookingModel.get('service_id'),
                    'products': this._bookingModel.getAddons(),
                    'count': this._bookingModel.get('count'),
                    'booking_id': this._bookingModel.id
                }
            });

            if (prev) {
                prev.abort();
            }
        },

	    /**
	     * Here you should return time view
	     * 
	     * @return Marionette.View
         * @protected
	     */
        _getTimeView: function () {
        }
        
    });
});
